module.exports = __webpack_public_path__ + "static/story_photo_03-ba1aed8d9c00a07d73b97de76b08da74.jpg";